<div class="detail-wrap"
     [style.height]="height + 'px'"
     *ngIf="example">

  <div class="detail-head-box">
    <div class="detail-menu">
      <div class="menu-wrap">
        <button type="button"
                class="help-btn"
                *ngIf="showHelpButton"
                (click)="onClickHelp($event)">도움말</button>
        <a class="detail-menu-btn close-btn"
           (click)="onClose()"></a>
      </div>
    </div>
  </div>

  <div class="detail-body">
    <div class="detail-item-list">

      <div class="detail-item-box"
           *ngIf="example.word1">
        <div class="word-list">
          <div class="word-box type-full">
            <div class="subject">단어</div>
            <div class="con">
              <div class="item-list">
                <ul>
                  <li app-word-disp-list-item
                      #listWord
                      [word]="example.word1"
                      [openPopup]="true"
                      [ngClass]="{'full': classFull}">
                  </li>
                  <li app-word-disp-list-item
                      *ngIf="example.word2"
                      #listWord
                      [word]="example.word2"
                      [openPopup]="true"
                      [ngClass]="{'full': classFull}">
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>

</div>
